import dayjs from "dayjs";
import {
  DATE_RANGE_PRESETS,
  DateRangePreset,
} from "./constants";

export function getPublishedRange(preset: DateRangePreset) {
  const config = DATE_RANGE_PRESETS.find((item) => item.value === preset);
  const days = config?.days ?? 365;

  return {
    publishedFrom: dayjs().subtract(days, "day").toISOString(),
    publishedTo: dayjs().toISOString(),
  };
}
